import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { Subscription } from 'rxjs';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { CreateDataFeedSharedService } from '../../create-data-feed-shared.service';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
    selector: 'cv-field-name-renderer',
    templateUrl: './field-name-renderer.component.html',
    styleUrls: ['./field-name-renderer.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class FieldNameRendererComponent implements ICellRendererAngularComp, OnInit {
    params: any;
    maxCharAllowed = 50;
    field_name: FormGroup;
    public dirtyFlag = false;
    public isFieldValid = false;
    subscription: Subscription;
    addFieldPlaceholder = '';
    isRequired = true;
    duplicateField = false;
    containsSpecialCharacter = false;
    containsOnlyNumbers = false;
    private isInitialLoad = true;
    showError = false;
    columnActualWidth: number;

    constructor(fb: FormBuilder, private createDataFeedSharedService: CreateDataFeedSharedService, private cvLocalizationService: CVLocalizationService) {
        this.field_name = fb.group({
            fieldName: [
                null,
                Validators.compose([Validators.required, Validators.maxLength(50), this.customValidatorForNumericCharacters.bind(this),
                this.customValidatorForSpecialCharacters.bind(this), this.customValidatorForDuplicateFieldName.bind(this)])
            ]
        });
    }

    async ngOnInit(): Promise<void> {
        await this.loadLocalization();
    }

    agInit(params: ICellRendererParams) {
        this.params = params;
        this.columnActualWidth = (params.column.getActualWidth() - 30);

        if (params.node.data?.fieldName != '') {
            this.field_name.setValue({ fieldName: params.node.data.fieldName });
            if (this.field_name.controls.fieldName.errors) {
                this.showError = true;
                this.params.node.data.fieldNameValid = false;
                this.notifyActionCell();
            } else {
                this.showError = false;
                this.params.node.data.fieldNameValid = true;
            }
        }
    }

    onKeydown(event: KeyboardEvent): void {
        const key = event.key;
        if (key === 'ArrowLeft' || key === 'ArrowRight' || key === 'ArrowUp' || key === 'ArrowDown') {
            event.stopPropagation(); 
        }
    }
    
    notifyActionCell() {
        this.createDataFeedSharedService.publishFieldNameDataChange(this.params);
    }

    public async loadLocalization() {
        try {
            await this.cvLocalizationService.GetSection('ETL_Data_Feed_Create');
        }
        catch {
            console.log('Failed to load localization for ETL_Data_Feed_Create');
        }
        finally {
            this.addFieldPlaceholder = this.getLocalizationString("Add_Field_Placeholder", "Add field name");
        }
    }

    public getLocalizationString(key: string, defaultValue: string): string {
        const baseString = this.cvLocalizationService.getCachedText("ETL_Data_Feed_Create", key, defaultValue);
        return baseString;
    }

    customValidatorForSpecialCharacters(control: FormControl) {
        if (this.params && this.params.context && control.value) {
            if (this.params.context.componentParent.checkForSpecialCharacters(control.value)) {
                this.containsSpecialCharacter = true;
                return { pattern: true };
            } else {
                this.containsSpecialCharacter = false;
            }
        }
        return null;
    }

    customValidatorForNumericCharacters(control: FormControl) {
        if (this.params && this.params.context && control.value) {
            if (this.params.context.componentParent.checkForNumericCharacters(control.value)) {
                this.containsOnlyNumbers = true;
                return { numericPattern: true };
            } else {
                this.containsOnlyNumbers = false;
            }
        }
        return null;
    }

    customValidatorForDuplicateFieldName(control: any) {
        if (this.params && this.params.context && control.value) {
            if (this.params.context.componentParent.checkForDuplicateFieldName(control.value, this.params.data.objectId)) {
                return { duplicateName: true };
            }
        }
        return null;
    }

    isEditable() {
        if (this.validGridRow()) {
            return this.params.node.data.editable;
        }
    }

    public validateField(): void {
        this.isFieldValid = this.field_name.valid;
        if (!this.dirtyFlag) {
            this.dirtyFlag = true;
        }
        if (!this.isInitialLoad) {
            this.params.node.data.fieldNameValid = this.field_name.valid;
        }
        if (this.params.node.data.fieldName != null)
            this.params.node.data.fieldName = this.params.node.data.fieldName.toUpperCase();
        this.notifyActionCell();
        this.isInitialLoad = false;
    }

    validGridRow() {
        return this.params.node.data ? true : false;
    }

    refresh() {
        return false;
    }
}
